import { BrandingColor } from 'store/types/branding';
import { CustomBranding } from '@ds/ui';

export function buildCustomBranding(
    colors: BrandingColor[] | undefined,
    fixEnabled: boolean
): CustomBranding {
    const buttonPrimaryBackground = colors?.find(c => c.name === 'buttonPrimaryBackground')?.value;
    const originalButtonPrimaryText = colors?.find(c => c.name === 'buttonPrimaryText')?.value;

    const sameColor = fixEnabled
        && !!buttonPrimaryBackground
        && !!originalButtonPrimaryText
        && buttonPrimaryBackground.toLowerCase() === originalButtonPrimaryText.toLowerCase();
    const buttonPrimaryText = sameColor ? undefined : originalButtonPrimaryText;

    return fixEnabled
        ? { buttonPrimaryBackground, buttonPrimaryText }
        : { buttonPrimaryBackground, buttonPrimaryText: originalButtonPrimaryText };
}
